export interface ProductState {
  saving: boolean;
};

export const initialProductState: ProductState = {
  saving: false
};

export function cloneState(other: ProductState): ProductState {
  return Object.assign({}, other);
}
